import { PageBlock } from '@xprog/prensa'
import { extractTemplateFromBlock } from 'brands/opopular/assets/pageblocks'
import { ComponentSwitch } from 'components/Base/Base.index'
import { VideoLiveWrap } from 'components/VideoLive'
import ColumnistSideBoxWidgetWrapper from 'components/Wrappers/ColumnistSideBoxWidget.index'
import ContinuousReadingWidgetWrapper from 'components/Wrappers/ContinuousReadingWrapper.index'
import RadioWidgetWrapper from 'components/Wrappers/RadioWidgetWrapper.index'
import JogosWidgetWrapper from 'components/Wrappers/JogosWidgetWrapper.index'
import GenericWidgetWrapper from 'components/Wrappers/GenericWidgetWrapper.index'
import TemplateSideBarLeftPageWrapper from 'components/Wrappers/TemplateSideBarLeftWrapper'
import SlotAutoFilterAwareWrapper from 'components/Wrappers/SlotAutoFilterAwareWrapper.index'
import StoriesSideBoxWidgetWrapper from 'components/Wrappers/StoriesSideBoxWidgetWrapper'
import find from 'lodash/find'
import get from 'lodash/get'
import map from 'lodash/map'
import { AssetsContext } from 'providers/Assets'
import { SlotsContext } from 'providers/Slots'
import React, { useContext } from 'react'
import { TeaserProps } from '@xprog/prensa/news/Teaser/types'
import { PageBlockProps } from '@xprog/prensa/news/PageBlock/types'
import AdsSlot from "../Ads/Ads.Slot";

export const PageBlockComponent = (dataProps) => {

  const assetsState = useContext(AssetsContext)
  const slotsState = useContext(SlotsContext)
  const slotLayouts = get(assetsState, 'assets.slotLayouts')
  const templates = get(assetsState, 'assets.templates')

  if (!dataProps ||!dataProps?.isOnline) {
    return <></>
  }
  const data = extractTemplateFromBlock(dataProps)

  let wrappers = {}
  let itemsData: any = get(data, 'items', [])
  let slotAutoLeftElements: any[] = get(data, 'slotAutoLeftElements', [])
  let slotAutoCenterElements: any[] = get(data, 'slotAutoCenterElements', [])
  let slotAutoRightElements: any[] = get(data, 'slotAutoRightElements', [])

  let isSideBoxTabFixed: boolean = false
  let slotLeftComponent: string = get(data, 'slotLeftComponent', '')

  if (slotLeftComponent === 'ArticleReadMoreList') {
    if (window.innerWidth < 768) {
      return null;
    }
    wrappers['columnCenter'] = {
      slotMiddle: {
        enabled: true,
        component: (items, renderItem) => (
          <ContinuousReadingWidgetWrapper
            items={items}
            renderItem={renderItem}
            itemsData={itemsData}
            slots={slotAutoCenterElements}
          />
        )
      }
    }
  }
  if (data?.slotTemplate === 'TemplateSideBoxJogos') {
    wrappers['columnLeft'] = {
      slotMiddle: {
        enabled: true,
        component: (items) => <JogosWidgetWrapper data={items} />
        , 
      }
    }
  }
  if (data?.slotTemplate === 'TemplateSideBoxRadio') {
    wrappers['columnLeft'] = {
      slotMiddle: {
        enabled: true,
        component: (items) => <RadioWidgetWrapper data={items} />
      }
    }
  }
  if (data?.slotTemplate === 'TemplateSideBoxGeneric') {
    wrappers['columnLeft'] = {
      slotMiddle: {
        enabled: true,
        component: (items) => <GenericWidgetWrapper data={items} />
      }
    }
  }
  if (data?.slotTemplate === 'TemplateSideBoxColumnist') {
    wrappers['columnLeft'] = {
      slotMiddle: {
        enabled: true,
        component: (items) => <ColumnistSideBoxWidgetWrapper data={items} />
      }
    }
  }
  if (data?.slotTemplate === 'TemplateSideBoxStories') {
    wrappers['columnLeft'] = {
      slotMiddle: {
        enabled: true,
        component: (items) => <StoriesSideBoxWidgetWrapper data={items} />
      }
    }
  }
  if (data?.slotTemplate === 'TemplateVideoLive') {
    wrappers['columnLeft'] = {
      slotMiddle: {
        enabled: true,
        component: (items) => <VideoLiveWrap {...data} />
      }
    }
  }
  if (data?.slotLeftReadMoreEnabled) {
    wrappers['columnLeft'] = {
      slotMiddle: {
        enabled: true,
        component: (items, renderItem) =>
          <SlotAutoFilterAwareWrapper policyId={data?.slotManualTopLeft} items={items} renderItem={renderItem} />
      }
    }
  }
  if (data?.slotCenterReadMoreEnabled) {
    wrappers['columnCenter'] = {
      slotMiddle: {
        enabled: true,
        component: (items, renderItem) =>
          <SlotAutoFilterAwareWrapper policyId={data?.slotManualTopCenter} items={items} renderItem={renderItem} />
      }
    }
  }
  if (data?.slotRightReadMoreEnabled) {
    wrappers['columnRight'] = {
      slotMiddle: {
        enabled: true,
        component: (items, renderItem) =>
          <SlotAutoFilterAwareWrapper policyId={data?.slotManualTopRight} items={items} renderItem={renderItem} />
      }
    }
  }

  const sideBoxTabsList = slotsState.sideBoxTabsList
  const sideBoxLeft = find(sideBoxTabsList, { name: 'slotLeft' })
  const sideBoxCenter = find(sideBoxTabsList, { name: 'slotCenter' })
  const sideBoxRight = find(sideBoxTabsList, { name: 'slotRight' })

  let isLeftHidden = get(sideBoxLeft, 'hidden', true)
  let cssLeftHidden = isSideBoxTabFixed && isLeftHidden ? { '.Left': { display: 'none' } } : {}

  let isCenterHidden = get(sideBoxCenter, 'hidden', true)
  let cssCenterHidden = isSideBoxTabFixed && isCenterHidden ? { '.Center': { display: 'none' } } : {}

  let isRightHidden = get(sideBoxRight, 'hidden', true)
  let cssRightHidden = isSideBoxTabFixed && isRightHidden ? { '.Right': { display: 'none' } } : {}

  const slotArray = [
    slotAutoLeftElements,
    slotAutoCenterElements,
    slotAutoRightElements,
    get(data, 'slotManualTopLeft', []),
    get(data, 'slotManualTopCenter', []),
    get(data, 'slotManualTopRight', []),
    get(data, 'slotManualBottomLeft', []),
    get(data, 'slotManualBottomCenter', []),
    get(data, 'slotManualBottomRight', []),
    get(data, 'slotManualExtra', []),
    get(data, 'slotManualExtraTop', [])
  ]

  const slotData: Array<Array<PageBlockProps>> = []
  map(slotArray, (slot) => {
    const columnData: Array<PageBlockProps> = []
    map(slot, (item) => {
      const idToSearch = `${item}`.replace('contentid/', 'policy:')
      const resultObject = find(itemsData, { id: idToSearch })
      if (resultObject) {
        columnData.push(resultObject)
      }
    })
    slotData.push(columnData)
  })

  if(data.slotTemplate === 'Template100') {
    if(slotData[0].length == 1) {
      const customProps = {
        local: 'Super Manchete',
        teaserType: 'especial',
        //[AVISO]: Script de analytics está sendo desabilitado para usar Chartbeat e Google Analytics para gerar os dados no BI,
        // quando confirmado a migração, remover.
        // page: window.AnalyticsGJC.loadMoreCurrentPage,
        ...slotData[0][0]?.customProps
      }
      slotData[0][0].customProps = customProps;
    }
  } else if (data.slotTemplate === 'Template5050100') {
    if(slotData[0].length === 1) {
      const customProps = {
        local: 'Manchete',
        teaserType: 'especial',
        //[AVISO]: Script de analytics está sendo desabilitado para usar Chartbeat e Google Analytics para gerar os dados no BI,
        // quando confirmado a migração, remover.
        // page: window.AnalyticsGJC.loadMoreCurrentPage,
        ...slotData[0][0]?.customProps
      }
      slotData[0][0].customProps = customProps
    }
    slotData[1].forEach(slot => {
    const customProps = {
        local: 'Principal',
        teaserType: 'normal',
        //[AVISO]: Script de analytics está sendo desabilitado para usar Chartbeat e Google Analytics para gerar os dados no BI,
        // quando confirmado a migração, remover.
        // page: window.AnalyticsGJC.loadMoreCurrentPage,
        ...slotData[0][0]?.customProps
      }
      slot.customProps = customProps
    });
  }

  const ComponentWrapped = (props) => {
    return <ComponentSwitch data={props} pageBlockId={data.id} />
  }

  const slotTemplate = get(data, 'slotTemplate')
  const slotLeftTeaserColor = get(data, 'slotLeftTeaserColor')
  const slotLeftTeaserValue = get(data, 'slotLeftTeaserValue')
  const slotCenterTeaserColor = get(data, 'slotCenterTeaserColor')
  const slotCenterTeaserValue = get(data, 'slotCenterTeaserValue')
  const slotRightTeaserColor = get(data, 'slotRightTeaserColor')
  const slotRightTeaserValue = get(data, 'slotRightTeaserValue')

  if (slotTemplate === 'TemplateSidebarLeft') {
    wrappers['columnCenter'] = {
      slotMiddle: {
        enabled: true,
        component: (items, renderItem) =>
          <TemplateSideBarLeftPageWrapper policyId={data?.slotManualTopCenter} items={items} renderItem={renderItem} />
      }
    }
  }

  let slotLayoutsStyled = { ...slotLayouts }

  const templatesStyled = {
    ...templates,
    [`${slotTemplate}`]: {
      ...templates?.[`${slotTemplate}`],
      css: {
        ...templates?.[`${slotTemplate}`]?.css,
        container: {
          ...templates?.[`${slotTemplate}`]?.css?.container,
          '.Left .TeaserNumber': {
            backgroundColor: `$${slotLeftTeaserColor}`
          },
          '.Left .TeaserSubjectText': {
            color: `$${slotLeftTeaserColor}`,
            textTransform: 'uppercase'
          },
          '.Left p.TeaserTitleText:before': {
            color: `$${slotLeftTeaserColor}`
          },
          '.Center .TeaserNumber': {
            backgroundColor: `$${slotCenterTeaserColor}`
          },
          '.Center .TeaserSubjectText': {
            color: `$${slotCenterTeaserColor}`,
            textTransform: 'uppercase'
          },
          '.Center p.TeaserTitleText:before': {
            color: `$${slotCenterTeaserColor}`
          },
          '.Right .TeaserNumber': {
            backgroundColor: `$${slotRightTeaserColor}`
          },
          '.Right .TeaserSubjectText': {
            color: `$${slotRightTeaserColor}`,
            textTransform: 'uppercase'
          },
          '.Right p.TeaserTitleText:before': {
            color: `$${slotRightTeaserColor}`
          },
          ...cssLeftHidden,
          ...cssCenterHidden,
          ...cssRightHidden
        }
      }
    }
  }

  return (
    <>
      <AdsSlot type="block" componentReference="top" data={data} />
      <PageBlock
        {...data}
        itemComponent={ComponentWrapped}
        slotLeftLayout={slotLeftTeaserValue}
        slotCenterLayout={slotCenterTeaserValue}
        slotRightLayout={slotRightTeaserValue}
        slotLeftColor={slotLeftTeaserColor}
        slotCenterColor={slotCenterTeaserColor}
        slotRightColor={slotRightTeaserColor}
        slotAutoLeftElements={get(slotData, '[0]')}
        slotAutoCenterElements={get(slotData, '[1]')}
        slotAutoRightElements={get(slotData, '[2]')}
        slotManualTopLeft={get(slotData, '[3]')}
        slotManualTopCenter={get(slotData, '[4]')}
        slotManualTopRight={get(slotData, '[5]')}
        slotManualBottomLeft={get(slotData, '[6]')}
        slotManualBottomCenter={get(slotData, '[7]')}
        slotManualBottomRight={get(slotData, '[8]')}
        slotManualExtra={get(slotData, '[9]')}
        slotManualExtraTop={get(slotData, '[10]')}
        slotLayouts={slotLayoutsStyled}
        templates={templatesStyled}
        templateBgColor={get(data, 'slotTemplateColor')}
        wrappers={wrappers}
      />
      <AdsSlot type="block" componentReference="bottom" data={data} />
    </>
  )
}

export default PageBlockComponent
